declare global {
  interface Window {
    dataLayer: any[];
  }
}

window.dataLayer = window.dataLayer || [];

const showLog = localStorage.getItem('ga4_show_log') === 'Y';

export function track(eventName: string, params: Record<string, any>) {
  gtag({event: eventName, ...params});
}

export function pageView(params: Record<string, any>) {
  gtag({event: 'page_view', ...params});
}

function gtag(params: Record<string, any>) {
  if (showLog) {
    console.log(`%c [GA4] event: ${params.event}`, 'color:#0f0;');
    console.table(params);
  }
  window.dataLayer.push(params);
}
